import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

window.requestAnimationFrame = window.requestAnimationFrame.bind(window);
gsap.registerPlugin(ScrollTrigger);

var ButtonPrimary = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-ButtonPrimary',
	};

	$.extend(true, this.options, options);

};

ButtonPrimary.prototype.init = function() {

	var self = this;

	// let hoverIsToggled = false;
	// let hoverAnimationTl;
	const $button = self.options.$el;
	const $buttonText = $button.find(`.${self.options.baseClass}__text`);
	const $buttonIcon = $button.find(`.${self.options.baseClass}__icon`);
	const $buttonBackground = $button.find(`.${self.options.baseClass}__background`);
	const $buttonInner = $button.find(`.${self.options.baseClass}__inner`);

	if (!self.options.$el.hasClass(`${self.options.baseClass}--buttonNoScrollAnimation`))
	{

		// animate in when in viewport

		gsap.timeline(
			{
				scrollTrigger: {
					trigger: $button,
					start: 'bottom 100%',
				},
				delay: .1
			}
		)
		.to($buttonBackground,
			{
				opacity: 1,
				duration: .25,
				ease: "expo.out",
			}
		)
		.to($buttonBackground,
			{
				opacity: 1,
				//width: "100%",
				left: 0,
				right: 0,
				duration: .6,
				ease: "expo.out",
			},
			"<.1"
		)
		.fromTo($buttonInner,
			{
				opacity:0,
				x: -20
			},
			{
				opacity: 1,
				x: 0,
				duration: .4,
				ease: "expo.out",
			},
			"<.2"
		);

	}

	var buttonTextX;

	if ($button.hasClass(`${self.options.baseClass}--buttonLarge`))
	{
		buttonTextX = -14;
	}
	else
	{
		buttonTextX = -10;
	}

	self.hoverAnimationTl = gsap
		.timeline({
			paused: true,
			reversed: true
		})
		.to($buttonText, {
			x: buttonTextX,
			duration: .3,
			ease: "expo.inout",
		})
		.to($buttonBackground, {
			//scaleX: .96,
			left: "2%",
			right: "2%",
			duration: .55,
			ease: "expo.out",
		}, "<")
		.to($buttonIcon, {
			x: 0,
			opacity: 1,
			visibility: "visible",
			duration: .3,
			ease: "expo.inout",
		}, "<");
	

	$button.on('mouseenter', () => {
		self.hoverAnimationTl.timeScale(1).play();
	});

	$button.on('mouseleave', () => {
		self.hoverAnimationTl.timeScale(1.3).reverse();
	});

};



export default ButtonPrimary;
